var position = $(window).scrollTop();
var lastOpen = null;

function menuScroll() {
  position = $(window).scrollTop();
  
  if (position < 50) {
    $(".nav-main").removeClass("nav-solid");
  } else {
    $(".nav-main").addClass("nav-solid");
  }
}

menuScroll();

$(window).on('scroll', function() {
  menuScroll();
});

$('#mobile-hamburger').on('click', function() {
  if ($('.nav-main').hasClass('nav-open')) {
    $('.nav-main').removeClass('nav-solid');
    $('.nav-main').removeClass('nav-open');
    $('body').removeClass('overflow-hidden');
  } else {
    $('.nav-main').addClass('nav-solid');
    $('.nav-main').addClass('nav-open');
    $('body').addClass('overflow-hidden');
  }
});

$(window).on('resize', function() {
  if ($(window).width() > 1200) {
    $('.nav-main').removeClass('nav-solid');
    $('.nav-main').removeClass('nav-open');
    $('body').removeClass('overflow-hidden');

    menuScroll();
  } else {
    $('.nav-main').removeClass('nav-solid');
    $('.nav-main').removeClass('nav-open');
    $('#main-nav').removeClass('show');
    $('body').removeClass('overflow-hidden');

    menuScroll();
  }

  /** Close menu when we resize to avoid issues */
  $(".dropdown-toggle").each(function() {
    $(this).dropdown('hide');
  });
  $('#menu-overlay').hide();

}).resize();

/** Enable dropdowns */
$('.dropdown-toggle').dropdown();

$(".dropdown-toggle").on("show.bs.dropdown", function(event){
  var navHeight = $('.nav-main').outerHeight();
  var $dropdownMenu = $(event.relatedTarget).parents('li').find('.dropdown-menu');
  var dropdownContentHeight = $dropdownMenu.outerHeight() + 150;
  var viewportHeight = document.documentElement.clientHeight - navHeight;

  if (viewportHeight < dropdownContentHeight) {
    $dropdownMenu.css({
      'height': 'calc(100vh - '+navHeight+'px)'
    });
  } else {
    $dropdownMenu.css({
      'height': 'auto'
    });
  }
});

$(".dropdown-toggle").on("hide.bs.dropdown", function(event) {
  var $dropdownMenu = $(event.relatedTarget).parents('li').find('.dropdown-menu');
  
  $dropdownMenu.css({
    'height': 'auto'
  });
});

$('.dropdown-toggle').on('click', function() {
  var itemID = $(this).parent().attr('id');

  if (itemID == lastOpen) {
    $('#menu-overlay').toggle();
    $('html').toggleClass('overflow-hidden');
    itemID = null;
  } else if (lastOpen == null) {
    $('#menu-overlay').toggle();
    $('html').toggleClass('overflow-hidden');
  }
  lastOpen = itemID;
});

$('.menu-item .dropdown-menu').on('click', function(e) {
  e.stopPropagation();
});

$('#menu-overlay').on('click', function(e) {
  e.stopPropagation();
});

$('#menu-overlay, body').on('click', function(e) {
  if ($(e.target).closest('.dropdown-toggle').length === 0) {
    $(".dropdown-toggle").each(function() {
      $(this).dropdown('hide');
    });
    $('#menu-overlay').hide();
    $('html').removeClass('overflow-hidden');
    lastOpen = null;
  }
});